/* eslint-disable no-unused-vars */
import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";
import dayjs from "dayjs";
import _ from "lodash";
import store from "@/store";
import { i18n } from "../../main";
import {
  convertObjectToArray,
  extractAndRemoveLocale,
  processEventName,
} from "../../utils";
import {
  createTickets,
  createVariationProduct,
  fetchSectors,
} from "../../api/newEvent";
// CONFIGURAÇÃO DE COSTUMIZAÇÃO

Vue.prototype.$produtos_gerenciar = new Vue({
  data() {
    return {
      ENDPOINTS,
      dayjs: dayjs,
      produtosAddEdit: "new",
      modalSelectStore: false,
      loja_selecionada: "",
      lojas_loading: false,
      lote_loading: false,
      produtos_loading: false,
      pesquisar_loading: false,
      variacoes_loading: false,
      descriptionModal: false,
      descriptionTranslate: false,
      textModalConfirm: "",
      revertTaxa: false,
      cadastro: {
        tipoComissaoWeb: [],
        tipoComissaoPos: [],
        reverter_taxa: false,
        idproduto: "",
        loading: false,
        dados_cadastrais: {
          tipoComissaoWeb: "CONVENIENCIA",
          tipoComissaoPos: "COMISSAO",
          tipoTaxaWeb: "PERCENTUAL",
          tipoTaxaPos: "PERCENTUAL",
          carteira_digital: null,
          pre_venda: false,
          dthr_pre_venda: "",
          mapa_hospedagem: true,
          valor_taxa_web: "",
          percentual_taxa_web: "10",
          valor_taxa_pos: "",
          onProcessamento: false,
          percentual_taxa_pos: "7.4",
          comissao: "7.4",
          taxa_processamento: "",
          porcentagem_customizada: "",
          antecipacao: "",
          taxa_personalizada: "",
          dias_antecipacao: "",
          taxa_mes: "",
          ver_mais: false,
          descritivo_temp: [],
          descritivo: "",
          pais: "Brasil",
          estado: "",
          cidade: "",
          descricao_pt_br: "",
          descricao_en_us: "",
          descricao_es_es: "",
          descritivo_pt_br: "",
          descritivo_en_us: "",
          descritivo_es_es: "",
          url_iframe: "",
          url_link: "",
          status: "",
          loja: "",
          tipo: "INGRESSO",
          preco: 0,
          preco_promocional: 0,
          // custo: 0,
          estoque: 0,
          limite_venda_cpf: 0,
          sku: "",
          categoria: "",
          destaque: false,
          limitarIngressos: true,
          gerenciar_estoque: 1,
          tags: "",
          tem_traducao: false,
          endereco: "",
          dthr_apresentacao: null,
          canal_venda: "",
          controla_cancelamento: 1,
          dias_canc_apos_compra: 7,
          horas_canc_antes_evento: 24,
          prod_agrupamento: 0,
          exibe_agrupamento: 0,
          nidprod_agrupamento: "",
          comissoes: [
            { text: "7.4%", value: "7.4" },
            { text: "9.2%", value: "9.2" },
            { text: "15%", value: "15" },
            { text: "25%", value: "25" },
            { text: "Regra Personalizada", value: "personalizada" },
          ],
          error: {
            comissao: [],
            porcentagem_customizada: [],
            antecipacao: [],
            taxa_personalizada: [],
            dias_antecipacao: [],
            taxa_mes: [],
            descricao: [],
            descritivo: [],
            status: [],
            loja: [],
            tipo: [],
            preco: [],
            canal_venda: [],
            estoque: [],
            preco_promocional: [],
            categoria: [],
            sku: [],
            dthr_apresentacao: [],
            url_iframe: [],
            url_link: [],
            descritivo_pt_br: false,
            prod_agrupamento: [],
            exibe_agrupamento: [],
            nidprod_agrupamento: [],
          },
          vinculados: false,
          nidvinculados: "",
        },
        regra_acesso: {
          dias_antes: "",
          horas_antes: "",
          dias_depois: "",
          horas_depois: "",
          limite_uso: "",
          portador: 0,
          circus: false,
          is_facial: false,

          error: {
            dias_antes: [],
            horas_antes: [],
            dias_depois: [],
            horas_depois: [],
            limite_uso: [],
          },
        },
        periodo_vendas: {
          por_data_lote: 0,
          data_inicio: null,
          initDate: null,
          hora_inicio: null,
          initHour: null,
          data_termino: null,
          endDate: null,
          hora_termino: null,
          endHour: null,
          comeco_vendas_data: "",
          termino_vendas_data: "",
          termino_vendas_hora: "",
          error: {
            data_inicio: [],
            hora_inicio: [],
            data_termino: [],
            hora_termino: [],
          },
        },
        variacoes: {
          tem_variacoes: false,
          gerenciar_lote: false,
          opcoes: [],
          variacoes_produtos: [],
          variacao_pronto: true,
          error: {
            tipo: [],
          },
        },
        customizacao: {
          imagem: "",
          imagens_array: [],
          imagem_upload: {
            imagem: null,
          },
          loading_imagem: false,
          error: {
            imagem: [],
            imagem_upload: [],
          },
        },
        pre_visualizacao: {
          personalizar: "default",
          link: "https://empresateste.eleven360.com/products/",
          slug: "",
          error: {
            slug: [],
          },
        },
        cashless: {
          url_cashless_prod: "",
        },
      },
      produtos: [],
      produtos_original: [],
      tipos_produtos: [],
      tipos_variacao: [
        { value: "CORTESIA", text: "Cortesia" },
        { value: "GRATUIDADE", text: "Gratuidade" },
      ],
      status_produtos: [],
      loading_status_produtos: false,
      loading_canal_produtos: false,
      loja_prod: "",
      canal_venda: [],
      categorias_produtos: [],
      tipo_variacoes: [
        {
          key: "TEXTO",
          value: "Texto",
        },
        {
          key: "DATA",
          value: "Data",
        },
        {
          key: "HORA",
          value: "Hora",
        },
      ],
      removeOpcao: false,
      text: "",
      filtros: [],
      filter: {
        descricao: "",
        sku: "",
        loja: "",
        status: "",
        canal_venda: "",
        categoria: "",
      },
    };
  },
  computed: {
    tipoTaxaWeb() {
      return [
        { key: "PERCENTUAL", value: i18n.t("events.event-config.percentage") },
        { key: "VALOR", value: i18n.t("events.event-config.value") },
      ];
    },
    tipoTaxaPos() {
      return [
        { key: "PERCENTUAL", value: i18n.t("events.event-config.percentage") },
        { key: "VALOR", value: i18n.t("events.event-config.value") },
      ];
    },
  },
  methods: {
    validOptionsVariants(opcoes) {
      const correctStructure = opcoes.every(opcao => opcao.tipo !== "");

      if (!correctStructure) {
        const tipos = {};
        opcoes.forEach(opcao => {
          opcao.valor.forEach(item => {
            if (!tipos[item.tipo]) {
              tipos[item.tipo] = [];
            }

            const newItem = { ...item };
            newItem.idvariacao = newItem.idvariacao
              ? newItem.idvariacao
              : newItem.identificador;
            delete newItem.identificador;
            tipos[item.tipo].push(newItem);
          });
        });

        return Object.keys(tipos).map(tipo => ({
          tipo,
          pronto: false,
          valor: tipos[tipo],
        }));
      }

      return opcoes;
    },

    /**
     * @description Método para buscar os tipos de comissão
     */
    getTipoTaxas() {
      this.$axios
        .get(this.ENDPOINTS.LISTAR_TIPOS_TAXAS + "array")
        .then(response => {
          this.cadastro.tipoComissaoWeb = response;
          this.cadastro.tipoComissaoPos = response;
        });
    },
    getCanaisVenda() {
      this.loading_canal_produtos = true;
      this.$axios
        .get(this.ENDPOINTS.LISTAR_CANAIS_DE_VENDA_PRODUTO)
        .then(response => {
          this.$axios.setLocal("canal-produtos", response);
          this.canal_venda = response;
          this.loading_canal_produtos = false;
        });
    },
    getLojaID() {
      if (this.$axios.getLocal("oe_user_info")?.data?.user_type === "admin")
        return this.$axios.getLocal("loja_produtos_selecionada").data;
      else return this.$axios.getLocal("oe_user_info")?.data?.loja;
    },
    /**
     * @description Método para buscar tipos de variações
     */
    /**
     * @description Método para buscar tipos de produtos
     */
    getTiposProdutos() {
      this.$axios
        .get(`${this.ENDPOINTS.LISTAR_TIPOS_PRODUTOS}array`)
        .then(response => {
          this.$axios.setLocal("tipos-produtos", response);
          this.tipos_produtos = response;
        });
    },

    /**
     * @description Método para buscar status de produtos
     */
    getStatusProdutos() {
      this.loading_status_produtos = true;
      this.$axios
        .get(`${this.ENDPOINTS.LISTAR_STATUS_PRODUTOS}array`)
        .then(response => {
          this.$axios.setLocal("status-produtos", response);
          this.status_produtos = response;
          this.loading_status_produtos = false;
        });
    },

    /**
     * @description Método para buscar categorias de produtos
     */
    getProdutosCategoria() {
      this.$axios
        .post(this.ENDPOINTS.LISTAR_CATEGORIAS_PRODUTOS, {
          get_traduzido: true,
          lang: i18n.locale.substring(0, 2),
        })
        .then(response => {
          // AJUSTAR ISSO QUANDO UPLOAD DE IMAGENS NO SYNC FILE ESTIVER OK
          this.$axios.setLocal("categorias-produtos", response);
          this.categorias_produtos = response;
        });
    },

    /**
     * @description Método para deletar produto
     * @param {idproduto} String - id do produto
     */
    deletarProduto(idproduto) {
      this.$axios
        .delete(
          `${this.ENDPOINTS.LOJA_SEQUENCIADOR}${store.getters.storeSequencial}/${this.ENDPOINTS.DELETAR_PRODUTO}${idproduto}`
        )
        .then(() => {
          setTimeout(
            () =>
              store.dispatch("fetchEvents", {
                producerId: store.getters.storeSequencial,
              }),
            300
          );
        });
    },

    /**
     * @description Método para acessar produto na loja
     * @param {slug} String - Slug do produto
     */
    sendToProductLoja(slug, type, urlLink) {
      if (type === "LINK") {
        window.open(urlLink, "_blank");
      } else {
        let slug_loja = store.getters.storeInfo.slug
          ? store.getters.storeInfo.slug
          : store.getters.userInfo.slug;
        let env = process.env.NODE_ENV;
        let link = "";
        switch (env) {
          case "development": {
            link = "dev.eleventickets";
            break;
          }
          case "homolog": {
            link = "ah.eleventickets";
            break;
          }
          case "staging": {
            link = "staging.eleventickets";
            break;
          }
          case "production": {
            link = "eleventickets";
            break;
          }
          default: {
            link = "eleventickets";
            break;
          }
        }

        window.open(`https://${link}.com/${slug_loja}/${slug}`, "_blank");
      }
    },

    /**
     * @description Método para reverter taxa
     * @param {idproduto} String - id do produto
     */

    async reverterTaxa(idproduto) {
      this.$axios
        .put(
          `${this.ENDPOINTS.LOJA_SEQUENCIADOR}${store.getters.storeSequencial}/produto/${idproduto}/trocartaxa`
        )
        .then(() => {
          setTimeout(
            () =>
              store.dispatch("fetchEvents", {
                producerId: store.getters.storeSequencial,
              }),
            300
          );
          // this.cadastro.dados_cadastrais.tipoComissaoWeb = "CONVENIENCIA";
          // this.getProdutoById(idproduto);
          // this.alterarProduto();
        });
    },
    /**
     * @description Método para buscar produto pelo id
     * @param {loja} String - sequenciador da loja
     * @param {idproduto} String - id do produto
     * @param {type} String - tipo de funcionalidade (new - novo produto, edit - editar produto existente)
     * @param {index} String - indice do produto (caso seja edição)
     */
    getProdutoById(idproduto, type) {
      this.produtosAddEdit = type;
      // this.cadastro.loading = true
      if ((type === "editar" || type === "editar-evento") && idproduto === "")
        return;

      if (type === "new-event") {
        store.dispatch("clearLocations");
        store.commit("setCountry", "9e1bf96ca2754ee6596f26fd6e6b5cc2");
        store.dispatch("cleanImagesFromRegister");
        store.dispatch("cleanAll");
        store.commit("setEventType", "EVENTO");
        router.push({
          name: "newEventsSettings",
          params: { type: "cadastrar" },
        });
      } else if (type === "new-link") {
        store.dispatch("clearLocations");
        store.commit("setCountry", "9e1bf96ca2754ee6596f26fd6e6b5cc2");
        store.dispatch("cleanImagesFromRegister");
        store.dispatch("cleanAll");
        store.commit("setEventType", "LINK");
        router.push({
          name: "newEventsSettings",
          params: { type: "cadastrar" },
        });
      } else {
        this.$axios.setLocal("id_produto", idproduto);
        this.$axios
          .post(this.ENDPOINTS.GET_PRODUTO_BY_ID + idproduto, {
            loja: store.getters.storeSequencial,
          })
          .then(data => {
            const {
              idproduto,
              ver_mais,
              descricao,
              descritivo,
              url_iframe,
              url_link,
              end_pais,
              end_local,
              end_estado,
              end_cidade,
              status,
              canal_venda,
              tipo,
              preco,
              preco_promocional,
              custo,
              qtd_estoque,
              qtd_estoque_var,
              sku,
              idcategoria,
              destaque,
              limite_venda_cpf,
              gerenciar_estoque,
              tags,
              dthr_apresentacao,
              possui_lote,
              dias_antes,
              hr_antes,
              dias_depois,
              hr_depois,
              tipo_taxa_web,
              comissao_porcentagem_custom_web,
              comissao_web,
              tipo_taxa_pos,
              taxa_conveniencia_pos,
              valor_taxa_web,
              valor_taxa_pos,
              taxa_conveniencia_valor_custom_web,
              taxa_comissao_valor_custom_web,
              taxa_conveniencia_porcentagem_custom_web,
              taxa_conveniencia_web,
              taxa_comissao_porcentagem_custom_web,
              taxa_comissao_valor_custom_pos,
              taxa_conveniencia_valor_custom_pos,
              taxa_conveniencia_porcentagem_custom_pos,
              comissao_pos,
              comissao_porcentagem_custom_pos,
              percentual_taxa_pos,
              taxa_processamento,
              // comissao,
              limite_uso,
              circus,
              is_facial,
              troca_portador,
              dthr_inicio,
              dthr_termino,
              variantes,
              imagens,
              personalizar,
              horas_canc_antes_evento,
              dias_canc_apos_compra,
              controla_cancelamento,
              link,
              slug,
              url_cashless_prod,
              prod_agrupamento,
              exibe_agrupamento,
              nidprod_agrupamento,
              vinculado,
              nidvinculados,
              carteira_digital,
              pre_venda,
              dthr_pre_venda,
              show_map,
            } = data;
            if (type === "editar-evento") {
              store.commit("setCurrentEvent", data);
              store.commit("setIdEvent", idproduto);
              store.dispatch("getSectors", idproduto);
              router.push({
                name: "newEventsSettingsEdit",
                params: { type: "editar-evento" },
              });
            } else {
              router.push({
                name: "eventsSettings",
                params: { type: "editar" },
              });
            }

            if (data) {
              store.dispatch("getImagesFromRegister", imagens);
              store.commit("setImage2", imagens.imagem2);
              this.cadastro.idproduto = idproduto;
              // dados cadastrais
              if (descricao) {
                if (data.descricao.indexOf("<pt_BR>") > -1) {
                  this.cadastro.dados_cadastrais.descricao_pt_br =
                    descricao.substring(
                      descricao.indexOf("<pt_BR>") + 7,
                      descricao.indexOf("</pt_BR>")
                    );
                  this.cadastro.dados_cadastrais.descricao_en_us =
                    descricao.substring(
                      descricao.indexOf("<en_US>") + 7,
                      descricao.indexOf("</en_US>")
                    );
                  this.cadastro.dados_cadastrais.descricao_es_es =
                    descricao.substring(
                      descricao.indexOf("<es_ES>") + 7,
                      descricao.indexOf("</es_ES>")
                    );
                } else {
                  this.cadastro.dados_cadastrais.descricao_pt_br = descricao;
                }
              }

              if (descritivo) {
                if (descritivo.indexOf("<pt_BR>") > -1) {
                  this.cadastro.dados_cadastrais.descritivo_pt_br =
                    descritivo.substring(
                      descritivo.indexOf("<pt_BR>") + 7,
                      descritivo.indexOf("</pt_BR>")
                    );
                  this.cadastro.dados_cadastrais.descritivo_en_us =
                    descritivo.substring(
                      descritivo.indexOf("<en_US>") + 7,
                      descritivo.indexOf("</en_US>")
                    );
                  this.cadastro.dados_cadastrais.descritivo_es_es =
                    descritivo.substring(
                      descritivo.indexOf("<es_ES>") + 7,
                      descritivo.indexOf("</es_ES>")
                    );
                  this.cadastro.dados_cadastrais.descritivo = `<pt_BR>${this.cadastro.dados_cadastrais.descritivo_pt_br}</pt_BR><en_US>${this.cadastro.dados_cadastrais.descritivo_en_us}</en_US><es_ES>${this.cadastro.dados_cadastrais.descritivo_es_es}</es_ES>`;
                } else {
                  this.cadastro.dados_cadastrais.descritivo_pt_br = descritivo;
                }
              }
              this.cadastro.dados_cadastrais.ver_mais = ver_mais;
              this.cadastro.dados_cadastrais.url_iframe = url_iframe || "";
              this.cadastro.dados_cadastrais.url_link = url_link || "";
              this.cadastro.dados_cadastrais.pais = end_pais || "Brasil";
              this.cadastro.dados_cadastrais.estado = end_estado || "";
              this.cadastro.dados_cadastrais.cidade = end_cidade || "";
              this.cadastro.dados_cadastrais.mapa_hospedagem = show_map;
              this.cadastro.dados_cadastrais.status = status || "";
              this.cadastro.dados_cadastrais.canal_venda = canal_venda || "";
              // this.cadastro.dados_cadastrais.tipoComissaoWeb = tipo_taxa_web;
              if (tipo_taxa_web === "CONVENIENCIA") {
                this.cadastro.dados_cadastrais.tipoComissaoWeb = "CONVENIENCIA";
              } else {
                this.cadastro.dados_cadastrais.tipoComissaoWeb = "COMISSAO";
              }

              if (tipo_taxa_web === "COMISSAO") {
                if (comissao_web > 0) {
                  this.cadastro.dados_cadastrais.tipoTaxaWeb = "VALOR";
                  this.cadastro.dados_cadastrais.valor_taxa_web = comissao_web;
                } else {
                  this.cadastro.dados_cadastrais.tipoTaxaWeb = "PERCENTUAL";
                  this.cadastro.dados_cadastrais.percentual_taxa_web =
                    comissao_porcentagem_custom_web;
                }
              }

              if (tipo_taxa_web === "CONVENIENCIA") {
                if (taxa_conveniencia_web > 0) {
                  this.cadastro.dados_cadastrais.tipoTaxaWeb = "VALOR";
                  this.cadastro.dados_cadastrais.valor_taxa_web =
                    taxa_conveniencia_web;
                } else {
                  this.cadastro.dados_cadastrais.tipoTaxaWeb = "PERCENTUAL";
                  this.cadastro.dados_cadastrais.percentual_taxa_web =
                    taxa_conveniencia_porcentagem_custom_web;
                }
              }

              if (tipo_taxa_pos === "CONVENIENCIA") {
                this.cadastro.dados_cadastrais.tipoComissaoPos = "CONVENIENCIA";
              } else {
                this.cadastro.dados_cadastrais.tipoComissaoPos = "COMISSAO";
              }

              if (tipo_taxa_pos === "COMISSAO") {
                if (comissao_pos > 0) {
                  this.cadastro.dados_cadastrais.tipoTaxaPos = "VALOR";
                  this.cadastro.dados_cadastrais.valor_taxa_pos = comissao_pos;
                } else {
                  this.cadastro.dados_cadastrais.tipoTaxaPos = "PERCENTUAL";
                  this.cadastro.dados_cadastrais.percentual_taxa_pos =
                    comissao_porcentagem_custom_pos;
                }
              }

              if (tipo_taxa_pos === "CONVENIENCIA") {
                if (taxa_conveniencia_pos > 0) {
                  this.cadastro.dados_cadastrais.tipoTaxaPos = "VALOR";
                  this.cadastro.dados_cadastrais.valor_taxa_pos =
                    taxa_conveniencia_pos;
                } else {
                  this.cadastro.dados_cadastrais.tipoTaxaPos = "PERCENTUAL";
                  this.cadastro.dados_cadastrais.percentual_taxa_pos =
                    taxa_conveniencia_porcentagem_custom_pos;
                }
              }
              this.cadastro.dados_cadastrais.taxa_processamento =
                taxa_processamento ? taxa_processamento : "0";
              this.cadastro.dados_cadastrais.controla_cancelamento =
                controla_cancelamento;
              this.cadastro.dados_cadastrais.horas_canc_antes_evento =
                horas_canc_antes_evento || 24;
              this.cadastro.dados_cadastrais.dias_canc_apos_compra =
                dias_canc_apos_compra || 7;
              this.cadastro.dados_cadastrais.loja = "";
              this.cadastro.dados_cadastrais.tipo = tipo || "";
              this.cadastro.dados_cadastrais.preco = preco || "";
              this.cadastro.dados_cadastrais.limite_venda_cpf =
                limite_venda_cpf || 0;
              this.cadastro.dados_cadastrais.limitarIngressos = limite_venda_cpf
                ? true
                : false;
              this.cadastro.dados_cadastrais.preco_promocional =
                preco_promocional || 0;
              this.cadastro.dados_cadastrais.custo = custo || 0;
              this.cadastro.dados_cadastrais.estoque =
                qtd_estoque || qtd_estoque == 0
                  ? qtd_estoque
                  : qtd_estoque_var || qtd_estoque_var == 0
                  ? qtd_estoque_var
                  : 0;
              this.cadastro.dados_cadastrais.sku = sku || "";
              this.cadastro.dados_cadastrais.categoria = idcategoria || "";
              this.cadastro.dados_cadastrais.gerenciar_estoque =
                gerenciar_estoque;
              this.cadastro.dados_cadastrais.destaque =
                destaque === 1 ? true : false;
              this.cadastro.dados_cadastrais.endereco = end_local || "";
              this.cadastro.dados_cadastrais.tags = tags || "";
              this.cadastro.variacoes.gerenciar_lote = possui_lote || false;

              if (dthr_apresentacao) {
                this.cadastro.dados_cadastrais.dthr_apresentacao =
                  dthr_apresentacao
                    ? this.dayjs(dthr_apresentacao).format("DD/MM/YYYY HH:mm")
                    : null;
              }

              this.cadastro.dados_cadastrais.prod_agrupamento =
                prod_agrupamento;
              this.cadastro.dados_cadastrais.exibe_agrupamento =
                exibe_agrupamento;
              this.cadastro.dados_cadastrais.nidprod_agrupamento =
                nidprod_agrupamento ? nidprod_agrupamento.split(";") : [];

              // regras de acesso
              this.cadastro.regra_acesso.dias_antes = dias_antes || 0;
              this.cadastro.regra_acesso.horas_antes = hr_antes || 0;
              this.cadastro.regra_acesso.dias_depois = dias_depois || 0;
              this.cadastro.regra_acesso.horas_depois = hr_depois || 0;
              this.cadastro.regra_acesso.limite_uso = limite_uso || 0;
              this.cadastro.regra_acesso.portador = troca_portador === 1;
              this.cadastro.regra_acesso.circus = circus || false;
              this.cadastro.regra_acesso.is_facial = is_facial || false;
              // periodo de vendas
              if (dthr_inicio) {
                this.cadastro.periodo_vendas.data_inicio =
                  dthr_inicio.split(" ")[0] || null;
                this.cadastro.periodo_vendas.initDate =
                  dayjs(dthr_inicio.split(" ")[0]).format("DD/MM/YYYY") || null;
                this.cadastro.periodo_vendas.hora_inicio =
                  dthr_inicio.split(" ")[1] || null;
                this.cadastro.periodo_vendas.initHour =
                  dthr_inicio.split(" ")[1] || null;
              }

              if (dthr_termino) {
                this.cadastro.periodo_vendas.data_termino =
                  dthr_termino.split(" ")[0] || null;
                this.cadastro.periodo_vendas.endDate =
                  dayjs(dthr_termino.split(" ")[0]).format("DD/MM/YYYY") ||
                  null;
                this.cadastro.periodo_vendas.hora_termino =
                  dthr_termino.split(" ")[1] || null;
                this.cadastro.periodo_vendas.endHour =
                  dthr_termino.split(" ")[1] || null;
              }

              // variações
              if (
                variantes &&
                variantes.opcoes.length > 0 &&
                variantes.variacoes_produto.length > 0
              ) {
                this.cadastro.variacoes.tem_variacoes = true;
                const novoArray = [
                  {
                    tipo: "",
                    pronto: false,
                    valor: variantes.opcoes.map((obj, index) => ({
                      tem_traducao: false,
                      descricao: obj.descricao,
                      descricao_en_us: obj.descricao_en_us,
                      descricao_es_es: obj.descricao_es_es,
                      preco_default: obj.preco_default,
                      qtd_default: obj.qtd_default,
                      prioridade: obj.prioridade,
                      idvariacao: obj.idvariacao,

                      taxa: obj.taxa,
                      tipo: obj.tipo,
                    })),
                  },
                ];

                this.cadastro.variacoes.opcoes = novoArray;
                store.commit("setOptionVariations", novoArray);
                store.commit("setVariationsOld", variantes.variacoes_produto);
                store.commit("setVariations", variantes.variacoes_produto);
              }

              if (carteira_digital) {
                store.commit("setDigitalWallet", carteira_digital);
              }

              if (pre_venda) {
                this.cadastro.dados_cadastrais.pre_venda = pre_venda;
              }
              if (pre_venda && dthr_pre_venda) {
                this.cadastro.dados_cadastrais.dthr_pre_venda = dthr_pre_venda;
              }

              // costumização
              if (imagens) {
                this.cadastro.customizacao.imagens;
              }

              //  pre-visualização
              this.cadastro.pre_visualizacao.personalizar =
                personalizar || "default";
              this.cadastro.pre_visualizacao.link = link || "";
              this.cadastro.pre_visualizacao.slug = slug || "";

              this.cadastro.loading = false;

              // cashless
              this.cadastro.cashless.url_cashless_prod =
                url_cashless_prod || "";

              store.dispatch(
                "setHasLinkedEvents",
                vinculado === 1 ? true : false
              );

              const vinculos = nidvinculados ? nidvinculados.split(";") : [];
              store.dispatch("setLinkedEvents", { nidvinculados: vinculos });
            }
          });
      }
    },

    /**
     * @description Método para alterar produto existente
     */
    alterarProduto() {
      this.cadastro.loading = true;
      const imagesValues = store.getters.images.reduce((acc, obj) => {
        const type = obj.type;
        const url = obj.url;
        acc[type] = url;
        acc["imagem2"] = store.getters.image2;

        return acc;
      }, {});
      const dados = {
        loja: store.getters.storeSequencial,
        dados_cadastrais: {
          carteira_digital: store.getters.digitalWallet,
          pre_venda: this.cadastro.dados_cadastrais.pre_venda,
          dthr_pre_venda: this.cadastro.dados_cadastrais.pre_venda
            ? this.cadastro.dados_cadastrais.dthr_pre_venda
            : "",
          show_map: this.cadastro.dados_cadastrais.mapa_hospedagem,
          tipo_taxa_web: this.cadastro.dados_cadastrais.tipoComissaoWeb,
          taxa_conveniencia_web:
            this.cadastro.dados_cadastrais.tipoComissaoWeb === "CONVENIENCIA" &&
            this.cadastro.dados_cadastrais.tipoTaxaWeb === "VALOR"
              ? this.cadastro.dados_cadastrais.valor_taxa_web
              : "0",
          comissao_web:
            this.cadastro.dados_cadastrais.tipoComissaoWeb === "COMISSAO" &&
            this.cadastro.dados_cadastrais.tipoTaxaWeb === "VALOR"
              ? this.cadastro.dados_cadastrais.valor_taxa_web
              : "0",
          comissao_porcentagem_custom_web:
            this.cadastro.dados_cadastrais.tipoComissaoWeb === "COMISSAO" &&
            this.cadastro.dados_cadastrais.tipoTaxaWeb === "PERCENTUAL"
              ? this.cadastro.dados_cadastrais.percentual_taxa_web
              : "0",
          taxa_conveniencia_porcentagem_custom_web:
            this.cadastro.dados_cadastrais.tipoComissaoWeb === "CONVENIENCIA" &&
            this.cadastro.dados_cadastrais.tipoTaxaWeb === "PERCENTUAL"
              ? this.cadastro.dados_cadastrais.percentual_taxa_web
              : "0",

          tipo_taxa_pos: this.cadastro.dados_cadastrais.tipoComissaoPos,
          comissao_pos:
            this.cadastro.dados_cadastrais.tipoComissaoPos === "COMISSAO" &&
            this.cadastro.dados_cadastrais.tipoTaxaPos === "VALOR"
              ? this.cadastro.dados_cadastrais.valor_taxa_pos
              : "0",
          taxa_conveniencia_pos:
            this.cadastro.dados_cadastrais.tipoComissaoPos === "CONVENIENCIA" &&
            this.cadastro.dados_cadastrais.tipoTaxaPos === "VALOR"
              ? this.cadastro.dados_cadastrais.valor_taxa_pos
              : "0",
          comissao_porcentagem_custom_pos:
            this.cadastro.dados_cadastrais.tipoComissaoPos === "COMISSAO" &&
            this.cadastro.dados_cadastrais.tipoTaxaPos === "PERCENTUAL"
              ? this.cadastro.dados_cadastrais.percentual_taxa_pos
              : "0",
          taxa_conveniencia_porcentagem_custom_pos:
            this.cadastro.dados_cadastrais.tipoComissaoPos === "CONVENIENCIA" &&
            this.cadastro.dados_cadastrais.tipoTaxaPos === "PERCENTUAL"
              ? this.cadastro.dados_cadastrais.percentual_taxa_pos
              : "0",
          taxa_processamento: this.cadastro.dados_cadastrais.taxa_processamento,
          ver_mais: this.cadastro.dados_cadastrais.ver_mais,
          descricao: `<pt_BR>${this.cadastro.dados_cadastrais.descricao_pt_br}</pt_BR><en_US>${this.cadastro.dados_cadastrais.descricao_en_us}</en_US><es_ES>${this.cadastro.dados_cadastrais.descricao_es_es}</es_ES>`,
          descritivo: `<pt_BR>${this.cadastro.dados_cadastrais.descritivo_pt_br}</pt_BR><en_US>${this.cadastro.dados_cadastrais.descritivo_en_us}</en_US><es_ES>${this.cadastro.dados_cadastrais.descritivo_es_es}</es_ES>`,
          canal_venda:
            this.cadastro.dados_cadastrais.tipo != "IFRAME" &&
            this.cadastro.dados_cadastrais.tipo != "LINK"
              ? this.cadastro.dados_cadastrais.canal_venda
              : "ECOMMERCE;IFRAME;LINK" || "PDV_POS;ECOMMERCE;IFRAME;LINK",
          status: this.cadastro.dados_cadastrais.status,
          tipo: this.cadastro.dados_cadastrais.tipo,
          preco: Number(this.cadastro.dados_cadastrais.preco),
          preco_promocional: Number(
            this.cadastro.dados_cadastrais.preco_promocional
          ),
          limite_venda_cpf: Number(
            this.cadastro.dados_cadastrais.limite_venda_cpf
          ),
          custo:
            Number.parseFloat(this.cadastro.dados_cadastrais.custo) == null
              ? Number.parseFloat(0)
              : Number.parseFloat(this.cadastro.dados_cadastrais.custo),
          qtd_estoque: this.cadastro.dados_cadastrais.estoque,
          url_iframe: this.cadastro.dados_cadastrais.url_iframe,
          url_link: this.cadastro.dados_cadastrais.url_link,
          end_local: this.cadastro.dados_cadastrais.endereco,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado:
            this.cadastro.dados_cadastrais.estado?.iso ||
            this.cadastro.dados_cadastrais.estado,
          controla_cancelamento:
            this.cadastro.dados_cadastrais.controla_cancelamento === 1 ||
            this.cadastro.dados_cadastrais.controla_cancelamento === 2
              ? 1
              : 0,
          horas_canc_antes_evento:
            this.cadastro.dados_cadastrais.horas_canc_antes_evento,
          dias_canc_apos_compra:
            this.cadastro.dados_cadastrais.dias_canc_apos_compra,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          sku: this.cadastro.dados_cadastrais.sku,
          idcategoria: this.cadastro.dados_cadastrais.categoria,
          destaque: this.cadastro.dados_cadastrais.destaque ? 1 : 0,
          limitarIngressos: this.cadastro.dados_cadastrais.limite_venda_cpf
            ? 1
            : 0,
          gerenciar_estoque: this.cadastro.dados_cadastrais.gerenciar_estoque,
          tags: this.cadastro.dados_cadastrais.tags,
          slug: this.cadastro.pre_visualizacao.slug,
          endereco: this.cadastro.dados_cadastrais.endereco,
          dthr_apresentacao: this.cadastro.dados_cadastrais.dthr_apresentacao
            ? this.cadastro.dados_cadastrais.dthr_apresentacao.length <= 10
              ? this.$config.convertDataEN(
                  this.cadastro.dados_cadastrais.dthr_apresentacao
                ) + " 00:00"
              : this.$config.convertDataEN(
                  this.cadastro.dados_cadastrais.dthr_apresentacao.split(" ")[0]
                ) +
                " " +
                this.cadastro.dados_cadastrais.dthr_apresentacao.split(" ")[1]
            : null,
          imagens: JSON.stringify(imagesValues),
          possui_lote: this.cadastro.variacoes.gerenciar_lote,
          prod_agrupamento: this.cadastro.dados_cadastrais.prod_agrupamento,
          exibe_agrupamento: this.cadastro.dados_cadastrais.exibe_agrupamento,
          nidprod_agrupamento: this.cadastro.dados_cadastrais.prod_agrupamento
            ? this.cadastro.dados_cadastrais.nidprod_agrupamento.join(";")
            : "",
          vinculado:
            store.getters?.linkedEvents?.nidvinculados?.length > 0 ? 1 : 0,
          nidvinculados: store.getters?.linkedEvents?.nidvinculados?.join(";"),
        },
        regra_acesso: {
          dias_antes: this.cadastro.regra_acesso.dias_antes,
          hr_antes: this.cadastro.regra_acesso.horas_antes,
          dias_depois: this.cadastro.regra_acesso.dias_depois,
          hr_depois: this.cadastro.regra_acesso.horas_depois,
          limite_uso: this.cadastro.regra_acesso.limite_uso,
          troca_portador: this.cadastro.regra_acesso.portador ? 1 : 0,
          circus: this.cadastro.regra_acesso.circus,
          is_facial: this.cadastro.regra_acesso.is_facial,
        },
        periodo_vendas: {
          dthr_inicio: `${this.cadastro.periodo_vendas.data_inicio} ${this.cadastro.periodo_vendas.hora_inicio}`,
          dthr_termino: `${this.cadastro.periodo_vendas.data_termino} ${this.cadastro.periodo_vendas.hora_termino}`,
        },
        variantes: {
          opcoes: this.validOptionsVariants(store.getters.optionVariations),
          variacoes_produto: store.getters.variations,
        },
        pre_visualizacao: {
          personalizar: this.cadastro.pre_visualizacao.personalizar,
          link: this.cadastro.pre_visualizacao.link,
        },
        cashless: {
          url_cashless_prod: this.cadastro.cashless.url_cashless_prod || "",
        },
      };

      if (this.cadastro.dados_cadastrais.tipo === "RECARGA") {
        delete dados.regra_acesso;
      }

      this.$axios
        .put(this.ENDPOINTS.ALTERAR_PRODUTO + this.cadastro.idproduto, dados)
        .then(response => {
          if (response) {
            this.$axios.setLocal("confirmEditProduct", true);
            store.commit("setVariationsOld", []);
            // dados cadastrais
            store.dispatch("cleanImagesFromRegister"),
              store.commit("setDigitalWallet", [
                {
                  dias: "2",
                  tipo: "pos",
                  limite: 80,
                  saque: "manual",
                },
              ]);
            (this.cadastro.dados_cadastrais.descricao_pt_br = ""),
              (this.cadastro.dados_cadastrais.descritivo_en_us = ""),
              (this.cadastro.dados_cadastrais.descritivo_es_es = ""),
              (this.cadastro.dados_cadastrais.descritivo_pt_br = ""),
              (this.cadastro.dados_cadastrais.descritivo_en_us = ""),
              (this.cadastro.dados_cadastrais.descritivo_es_es = ""),
              (this.cadastro.dados_cadastrais.status = ""),
              (this.cadastro.dados_cadastrais.loja = ""),
              (this.cadastro.dados_cadastrais.tipo = ""),
              (this.cadastro.dados_cadastrais.url_iframe = ""),
              (this.cadastro.dados_cadastrais.url_link = ""),
              (this.cadastro.dados_cadastrais.preco = 0),
              (this.cadastro.dados_cadastrais.preco_promocional = 0),
              (this.cadastro.dados_cadastrais.limite_venda_cpf = 0),
              (this.cadastro.dados_cadastrais.custo = 0),
              (this.cadastro.dados_cadastrais.estoque = 0),
              (this.cadastro.dados_cadastrais.sku = ""),
              (this.cadastro.dados_cadastrais.categoria = ""),
              (this.cadastro.dados_cadastrais.valor_taxa_web = "");
            this.cadastro.dados_cadastrais.pre_venda = false;
            this.cadastro.dados_cadastrais.dthr_pre_venda = "";
            this.cadastro.dados_cadastrais.percentual_taxa_web = "10";
            this.cadastro.dados_cadastrais.tipoComissaoWeb = "CONVENIENCIA";
            this.cadastro.dados_cadastrais.tipoComissaoPos = "COMISSAO";
            this.cadastro.dados_cadastrais.tipoTaxaPos = "PERCENTUAL";
            this.cadastro.dados_cadastrais.percentual_taxa_pos = "7.4";
            this.cadastro.dados_cadastrais.valor_taxa_pos = "0";
            (this.cadastro.dados_cadastrais.tipoComissaoWeb = "CONVENIENCIA"),
              (this.cadastro.dados_cadastrais.tipoTaxaWeb = "PERCENTUAL"),
              (this.cadastro.dados_cadastrais.valor_taxa_web = "0"),
              (this.cadastro.dados_cadastrais.destaque = false),
              (this.cadastro.dados_cadastrais.controla_cancelamento = 1),
              (this.cadastro.dados_cadastrais.horas_canc_antes_evento = 24),
              (this.cadastro.dados_cadastrais.dias_canc_apos_compra = 7),
              (this.cadastro.dados_cadastrais.gerenciar_estoque = 1),
              (this.cadastro.dados_cadastrais.tags = ""),
              (this.cadastro.dados_cadastrais.endereco = ""),
              (this.cadastro.dados_cadastrais.dthr_apresentacao = null),
              (this.cadastro.dados_cadastrais.gerenciar_lote = false),
              (this.cadastro.dados_cadastrais.canal_venda = ""),
              (this.cadastro.dados_cadastrais.pais = "Brasil"),
              (this.cadastro.dados_cadastrais.estado = ""),
              (this.cadastro.dados_cadastrais.cidade = ""),
              (this.cadastro.dados_cadastrais.mapa_hospedagem = true),
              (this.cadastro.dados_cadastrais.prod_agrupamento = 0),
              (this.cadastro.dados_cadastrais.exibe_agrupamento = 0),
              (this.cadastro.dados_cadastrais.nidprod_agrupamento = ""),
              // regras de acesso
              (this.cadastro.regra_acesso.dias_antes = ""),
              (this.cadastro.regra_acesso.horas_antes = ""),
              (this.cadastro.regra_acesso.dias_depois = ""),
              (this.cadastro.regra_acesso.horas_depois = ""),
              (this.cadastro.regra_acesso.limite_uso = ""),
              (this.cadastro.regra_acesso.portador = 0),
              // periodo de vendas
              (this.cadastro.periodo_vendas.por_data_lote = 0),
              (this.cadastro.periodo_vendas.data_inicio = null),
              (this.cadastro.periodo_vendas.initDate = null),
              (this.cadastro.periodo_vendas.hora_inicio = null),
              (this.cadastro.periodo_vendas.initHour = null),
              (this.cadastro.periodo_vendas.data_termino = null),
              (this.cadastro.periodo_vendas.endDate = null),
              (this.cadastro.periodo_vendas.hora_termino = null),
              (this.cadastro.periodo_vendas.endHour = null),
              (this.cadastro.periodo_vendas.comeco_vendas_data = ""),
              (this.cadastro.periodo_vendas.termino_vendas_data = ""),
              (this.cadastro.periodo_vendas.termino_vendas_hora = ""),
              // variações
              (this.cadastro.variacoes.tem_variacoes = false),
              (this.cadastro.variacoes.opcoes = []),
              (this.cadastro.variacoes.variacoes_produtos = []),
              // customização
              (this.cadastro.customizacao.imagem = ""),
              (this.cadastro.customizacao.imagens_array = []),
              (this.cadastro.customizacao.imagens_array.imagem = null),
              //  pre-visualização
              (this.cadastro.pre_visualizacao.personalizar = "default"),
              (this.cadastro.pre_visualizacao.link =
                "https://empresateste.eleven360.com/products/"),
              (this.cadastro.pre_visualizacao.slug = ""),
              router.push({
                name: "events",
              });

            this.$produtos_gerenciar.loja_selecionada =
              store.getters.storeSequencial;
          }
          this.cadastro.loading = false;
        })
        .catch(error => {
          // console.error(error);
          this.cadastro.loading = false;
          throw new Error(error);
        })
        .finally(() => {
          store.dispatch("fetchEvents", {
            producerId: store.getters.storeSequencial,
          });
        });
    },

    /**
     * @description Método para cadastrar novo produto
     */
    async cadastrarProduto() {
      this.cadastro.loading = true;

      // tratamento de imagens

      this.cadastro.variacoes.opcoes.forEach(item => {
        if (item.tipo == "DATA") {
          item.valor.forEach(element => {
            element.descricao = this.$config.convertDataEN(element.descricao);
          });
        }
      });

      const imagesValues = store.getters.images.reduce((acc, obj) => {
        const type = obj.type;
        const url = obj.url;
        acc[type] = url;
        acc["imagem2"] = store.getters.image2;

        return acc;
      }, {});

      const dados = {
        loja: store.getters.storeSequencial,
        dados_cadastrais: {
          carteira_digital: store.getters.digitalWallet,
          pre_venda: this.cadastro.dados_cadastrais.pre_venda,
          dthr_pre_venda: this.cadastro.dados_cadastrais.pre_venda
            ? this.cadastro.dados_cadastrais.dthr_pre_venda
            : "",
          show_map: this.cadastro.dados_cadastrais.mapa_hospedagem,
          tipo_taxa_web: this.cadastro.dados_cadastrais.tipoComissaoWeb,
          taxa_conveniencia_web:
            this.cadastro.dados_cadastrais.tipoComissaoWeb === "CONVENIENCIA" &&
            this.cadastro.dados_cadastrais.tipoTaxaWeb === "VALOR"
              ? this.cadastro.dados_cadastrais.valor_taxa_web
              : "0",
          comissao_web:
            this.cadastro.dados_cadastrais.tipoComissaoWeb === "COMISSAO" &&
            this.cadastro.dados_cadastrais.tipoTaxaWeb === "VALOR"
              ? this.cadastro.dados_cadastrais.valor_taxa_web
              : "0",
          comissao_porcentagem_custom_web:
            this.cadastro.dados_cadastrais.tipoComissaoWeb === "COMISSAO" &&
            this.cadastro.dados_cadastrais.tipoTaxaWeb === "PERCENTUAL"
              ? this.cadastro.dados_cadastrais.percentual_taxa_web
              : "0",
          taxa_conveniencia_porcentagem_custom_web:
            this.cadastro.dados_cadastrais.tipoComissaoWeb === "CONVENIENCIA" &&
            this.cadastro.dados_cadastrais.tipoTaxaWeb === "PERCENTUAL"
              ? this.cadastro.dados_cadastrais.percentual_taxa_web
              : "0",

          tipo_taxa_pos: this.cadastro.dados_cadastrais.tipoComissaoPos,
          comissao_pos:
            this.cadastro.dados_cadastrais.tipoComissaoPos === "COMISSAO" &&
            this.cadastro.dados_cadastrais.tipoTaxaPos === "VALOR"
              ? this.cadastro.dados_cadastrais.valor_taxa_pos
              : "0",
          taxa_conveniencia_pos:
            this.cadastro.dados_cadastrais.tipoComissaoPos === "CONVENIENCIA" &&
            this.cadastro.dados_cadastrais.tipoTaxaPos === "VALOR"
              ? this.cadastro.dados_cadastrais.valor_taxa_pos
              : "0",
          comissao_porcentagem_custom_pos:
            this.cadastro.dados_cadastrais.tipoComissaoPos === "COMISSAO" &&
            this.cadastro.dados_cadastrais.tipoTaxaPos === "PERCENTUAL"
              ? this.cadastro.dados_cadastrais.percentual_taxa_pos
              : "0",
          taxa_conveniencia_porcentagem_custom_pos:
            this.cadastro.dados_cadastrais.tipoComissaoPos === "CONVENIENCIA" &&
            this.cadastro.dados_cadastrais.tipoTaxaPos === "PERCENTUAL"
              ? this.cadastro.dados_cadastrais.percentual_taxa_pos
              : "0",
          taxa_processamento: this.cadastro.dados_cadastrais.taxa_processamento,
          ver_mais: this.cadastro.dados_cadastrais.ver_mais,
          descricao: `<pt_BR>${this.cadastro.dados_cadastrais.descricao_pt_br}</pt_BR><en_US>${this.cadastro.dados_cadastrais.descricao_en_us}</en_US><es_ES>${this.cadastro.dados_cadastrais.descricao_es_es}</es_ES>`,
          descritivo: `<pt_BR>${this.cadastro.dados_cadastrais.descritivo_pt_br}</pt_BR><en_US>${this.cadastro.dados_cadastrais.descritivo_en_us}</en_US><es_ES>${this.cadastro.dados_cadastrais.descritivo_es_es}</es_ES>`,
          canal_venda:
            this.cadastro.dados_cadastrais.tipo != "IFRAME" &&
            this.cadastro.dados_cadastrais.tipo != "LINK"
              ? this.cadastro.dados_cadastrais.canal_venda
              : "ECOMMERCE;IFRAME;LINK" || "PDV_POS;ECOMMERCE;IFRAME;LINK",
          status: this.cadastro.dados_cadastrais.status,
          tipo: this.cadastro.dados_cadastrais.tipo,
          preco: Number.parseFloat(this.cadastro.dados_cadastrais.preco),
          preco_promocional: Number.parseFloat(
            this.cadastro.dados_cadastrais.preco_promocional
          ),
          limite_venda_cpf: Number.parseFloat(
            this.cadastro.dados_cadastrais.limite_venda_cpf
          ),
          custo:
            Number.parseFloat(this.cadastro.dados_cadastrais.custo) == null
              ? Number.parseFloat(0)
              : Number.parseFloat(this.cadastro.dados_cadastrais.custo),
          qtd_estoque: this.cadastro.dados_cadastrais.estoque,
          url_iframe: this.cadastro.dados_cadastrais.url_iframe,
          url_link: this.cadastro.dados_cadastrais.url_link,
          end_local: this.cadastro.dados_cadastrais.endereco,
          end_pais: this.cadastro.dados_cadastrais.pais,
          end_estado: this.cadastro.dados_cadastrais.estado?.iso,
          end_cidade: this.cadastro.dados_cadastrais.cidade,
          sku: this.cadastro.dados_cadastrais.sku,
          idcategoria: this.cadastro.dados_cadastrais.categoria,
          tags: this.cadastro.dados_cadastrais.tags,
          controla_cancelamento:
            this.cadastro.dados_cadastrais.controla_cancelamento === 1 ||
            this.cadastro.dados_cadastrais.controla_cancelamento === 2
              ? 1
              : 0,
          dias_canc_apos_compra:
            this.cadastro.dados_cadastrais.dias_canc_apos_compra,
          horas_canc_antes_evento:
            this.cadastro.dados_cadastrais.horas_canc_antes_evento,
          gerenciar_estoque: this.cadastro.dados_cadastrais.gerenciar_estoque,
          destaque: this.cadastro.dados_cadastrais.destaque ? 1 : 0,
          slug: this.cadastro.pre_visualizacao.slug,
          endereco: this.cadastro.dados_cadastrais.endereco,
          dthr_apresentacao: this.cadastro.dados_cadastrais.dthr_apresentacao
            ? this.cadastro.dados_cadastrais.dthr_apresentacao.length <= 10
              ? this.$config.convertDataEN(
                  this.cadastro.dados_cadastrais.dthr_apresentacao
                ) + " 00:00"
              : this.$config.convertDataEN(
                  this.cadastro.dados_cadastrais.dthr_apresentacao.split(" ")[0]
                ) +
                " " +
                this.cadastro.dados_cadastrais.dthr_apresentacao.split(" ")[1]
            : null,
          imagens: JSON.stringify(imagesValues),
          possui_lote: this.cadastro.variacoes.gerenciar_lote,
          prod_agrupamento: this.cadastro.dados_cadastrais.prod_agrupamento,
          exibe_agrupamento: this.cadastro.dados_cadastrais.exibe_agrupamento,
          nidprod_agrupamento: this.cadastro.dados_cadastrais.prod_agrupamento
            ? this.cadastro.dados_cadastrais.nidprod_agrupamento.join(";")
            : "",
          nidvinculados: store.getters?.linkedEvents?.nidvinculados?.join(";"),
          vinculado:
            store.getters?.linkedEvents?.nidvinculados?.length > 0 ? 1 : 0,
        },
        regra_acesso: {
          dias_antes: this.cadastro.regra_acesso.dias_antes,
          hr_antes: this.cadastro.regra_acesso.horas_antes,
          dias_depois: this.cadastro.regra_acesso.dias_depois,
          hr_depois: this.cadastro.regra_acesso.horas_depois,
          limite_uso: this.cadastro.regra_acesso.limite_uso,
          troca_portador: this.cadastro.regra_acesso.portador ? 1 : 0,
          circus: this.cadastro.regra_acesso.circus,
          is_facial: this.cadastro.regra_acesso.is_facial,
        },
        periodo_vendas: {
          dthr_inicio: `${this.cadastro.periodo_vendas.data_inicio} ${this.cadastro.periodo_vendas.hora_inicio}`,
          dthr_termino: `${this.cadastro.periodo_vendas.data_termino} ${this.cadastro.periodo_vendas.hora_termino}`,
        },
        variantes: {
          opcoes: this.validOptionsVariants(store.getters.optionVariations),
          variacoes_produto: store.getters.variations,
        },
        pre_visualizacao: {
          personalizar: this.cadastro.pre_visualizacao.personalizar,
          link: this.cadastro.pre_visualizacao.link,
        },
        cashless: {
          url_cashless_prod: this.cadastro.cashless.url_cashless_prod || "",
        },
      };

      if (this.cadastro.dados_cadastrais.tipo === "RECARGA") {
        delete dados.regra_acesso;
      }

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_PRODUTO, dados)
        .then(response => {
          if (response) {
            // dados cadastrais
            store.commit("setDigitalWallet", [
              {
                dias: "2",
                tipo: "pos",
                limite: 80,
                saque: "manual",
              },
            ]);
            store.commit("setVariationsOld", null);
            store.dispatch("cleanImagesFromRegister"),
              (this.cadastro.dados_cadastrais.descritivo_pt_br = ""),
              (this.cadastro.dados_cadastrais.descritivo_en_us = ""),
              (this.cadastro.dados_cadastrais.descritivo_es_es = ""),
              (this.cadastro.dados_cadastrais.descritivo_pt_br = ""),
              (this.cadastro.dados_cadastrais.descritivo_en_us = ""),
              (this.cadastro.dados_cadastrais.descritivo_es_es = ""),
              (this.cadastro.dados_cadastrais.valor_taxa_web = "");
            this.cadastro.dados_cadastrais.pre_venda = false;
            this.cadastro.dados_cadastrais.dthr_pre_venda = "";
            this.cadastro.dados_cadastrais.percentual_taxa_web = "10";
            this.cadastro.dados_cadastrais.tipoComissaoWeb = "CONVENIENCIA";
            this.cadastro.dados_cadastrais.tipoComissaoPos = "COMISSAO";
            this.cadastro.dados_cadastrais.tipoTaxaPos = "PERCENTUAL";
            this.cadastro.dados_cadastrais.percentual_taxa_pos = "7.4";
            this.cadastro.dados_cadastrais.valor_taxa_pos = "0";
            (this.cadastro.dados_cadastrais.tipoComissaoWeb = "CONVENIENCIA"),
              (this.cadastro.dados_cadastrais.tipoTaxaWeb = "PERCENTUAL"),
              (this.cadastro.dados_cadastrais.valor_taxa_web = "0"),
              (this.cadastro.dados_cadastrais.status = ""),
              (this.cadastro.dados_cadastrais.loja = ""),
              (this.cadastro.dados_cadastrais.tipo = ""),
              (this.cadastro.dados_cadastrais.preco = 0),
              (this.cadastro.dados_cadastrais.controla_cancelamento = 1),
              (this.cadastro.dados_cadastrais.horas_canc_antes_evento = 24),
              (this.cadastro.dados_cadastrais.dias_canc_apos_compra = 7),
              (this.cadastro.dados_cadastrais.preco_promocional = 0),
              (this.cadastro.dados_cadastrais.custo = 0),
              (this.cadastro.dados_cadastrais.limite_venda_cpf = 0),
              (this.cadastro.dados_cadastrais.estoque = 0),
              (this.cadastro.dados_cadastrais.sku = ""),
              (this.cadastro.dados_cadastrais.categoria = ""),
              (this.cadastro.dados_cadastrais.destaque = false),
              (this.cadastro.dados_cadastrais.gerenciar_estoque = 1),
              (this.cadastro.dados_cadastrais.tags = ""),
              (this.cadastro.dados_cadastrais.endereco = ""),
              (this.cadastro.dados_cadastrais.canal_venda = ""),
              (this.cadastro.dados_cadastrais.url_iframe = ""),
              (this.cadastro.dados_cadastrais.url_link = ""),
              (this.cadastro.dados_cadastrais.dthr_apresentacao = null),
              (this.cadastro.dados_cadastrais.pais = "Brasil"),
              (this.cadastro.dados_cadastrais.estado = ""),
              (this.cadastro.dados_cadastrais.cidade = ""),
              (this.cadastro.dados_cadastrais.mapa_hospedagem = ""),
              (this.cadastro.variacoes.gerenciar_lote = false),
              (this.cadastro.dados_cadastrais.prod_agrupamento = 0),
              (this.cadastro.dados_cadastrais.exibe_agrupamento = 0),
              (this.cadastro.dados_cadastrais.nidprod_agrupamento = ""),
              // regras de acesso
              (this.cadastro.regra_acesso.dias_antes = ""),
              (this.cadastro.regra_acesso.horas_antes = ""),
              (this.cadastro.regra_acesso.dias_depois = ""),
              (this.cadastro.regra_acesso.horas_depois = ""),
              (this.cadastro.regra_acesso.limite_uso = ""),
              (this.cadastro.regra_acesso.portador = 0),
              // periodo de vendas
              (this.cadastro.periodo_vendas.por_data_lote = 0),
              (this.cadastro.periodo_vendas.data_inicio = null),
              (this.cadastro.periodo_vendas.hora_inicio = null),
              (this.cadastro.periodo_vendas.data_termino = null),
              (this.cadastro.periodo_vendas.hora_termino = null),
              (this.cadastro.periodo_vendas.comeco_vendas_data = ""),
              (this.cadastro.periodo_vendas.termino_vendas_data = ""),
              (this.cadastro.periodo_vendas.termino_vendas_hora = ""),
              // variações
              (this.cadastro.variacoes.tem_variacoes = false),
              (this.cadastro.variacoes.opcoes = []),
              (this.cadastro.variacoes.variacoes_produtos = []),
              // customização
              (this.cadastro.customizacao.imagem = ""),
              (this.cadastro.customizacao.imagens_array = []),
              (this.cadastro.customizacao.imagens_array.imagem = null),
              //  pre-visualização
              (this.cadastro.pre_visualizacao.personalizar = "default"),
              (this.cadastro.pre_visualizacao.link =
                "https://empresa.eleven360.com/products/"),
              (this.cadastro.pre_visualizacao.slug = "");

            if (
              this.$axios.getLocal("oe_user_info")?.data?.user_type ===
                "loja" &&
              this.$axios.getLocal("oe_user_info")?.data?.loja_status !==
                "ATIVO"
            ) {
              router.push("/primeiros-passos");
              return;
            }

            router.push({
              name: "events",
            });

            this.$produtos_gerenciar.loja_selecionada =
              store.getters.storeSequencial;
          }
          this.cadastro.loading = false;
        })
        .catch(error => {
          this.cadastro.loading = false;
          throw new Error(error);
        })
        .finally(() => {
          store.dispatch("fetchEvents", {
            producerId: store.getters.storeSequencial,
          });
        });
    },
    /**
     * @description Método para abrir o modal de confirmação de remoção de produto
     * @param {id} String - ID do produto
     * @param {msg} String - Mensagem de confirmação
     */
    remover(id, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.cadastro.idproduto = id;
    },

    /**
     * @description Método de confirmação de remoção de produto
     */
    funcaoRemover() {
      this.deletarProduto(this.cadastro.idproduto);
    },

    /**
     * @description Método filtrar produtos
     */
    filtroProdutos() {
      this.produtos_loading = true;
      this.pesquisar_loading = true;
      this.filtros = [];
      let filtered;
      filtered = this.filtros;
      if (this.filter.descricao != "") {
        this.filtros.push({
          campo: "prod.descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }
      if (this.filter.canal_venda != "" && this.filter.canal_venda != null) {
        this.filtros.push({
          campo: "prod.canal_venda",
          tipo: "string",
          valor: this.filter.canal_venda,
        });
      }
      if (this.filter.status != "" && this.filter.status != null) {
        this.filtros.push({
          campo: "prod.status",
          tipo: "string",
          valor: this.filter.status,
        });
      }
      if (this.filter.categoria != "" && this.filter.categoria != null) {
        this.filtros.push({
          campo: "prod.idcategoria",
          tipo: "string",
          valor: this.filter.categoria,
        });
      }
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_PRODUTO,
          JSON.stringify({
            loja: store.getters.storeSequencial,
            filtros: filtered,
            lang: "pt",
          })
        )
        .then(response => {
          this.produtos = response;
          this.produtos_loading = false;
          this.pesquisar_loading = false;
        });
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    /**
     * @description Método para repôr caracteres especiais em um texto
     * @param {str} String - string a ser reposta
     */
    replaceSpecialCharsAndSpaces(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str.replace(" ", "-");
      // o resto
      return str.replace(/[^a-z0-9]/gi, "-");
    },

    /**
     * @description Método para transformar uma string em slug
     * @param {str} String - string a ser transformada
     */
    transformToSlug(str) {
      str = str.toLowerCase();
      str = str.replace(/[ÀÁÂÃÄÅ]/, "a");
      str = str.replace(/[àáâãäå]/, "a");
      str = str.replace(/[ÈÉÊË]/, "e");
      str = str.replace(/[êéêë]/, "e");
      str = str.replace(/[íì]/, "i");
      str = str.replace(/[ÍÌ]/, "i");
      str = str.replace(/[Ç]/, "c");
      str = str.replace(/[ç]/, "c");
      str = str.replace(":", "");
      str = str.replace("-", "");
      str = str.replace("- ", "");
      str = str.replace(" ", "-");

      return str.replace(/[^a-z0-9]/gi, "-");
    },

    /**
     * @description Método para transformar um array em uma string
     * @param {array} String - array a ser transformado
     */
    transformArrayInString(array) {
      let string = "";
      for (let i = 0; i < array.length; i++) {
        string += array[i];
        if (i < array.length - 1) {
          string += "";
        }
      }
      return string;
    },

    /**
     * @description Método para validar se os campo obrigatórios estão preenchidos e se os campos estão corretos
     */
    async validarCadastro() {
      const someProductWithOptionDate = this.cadastro.variacoes.opcoes.some(
        item => {
          return item.tipo === "DATA";
        }
      );
      if (
        this.cadastro.dados_cadastrais.tipo !== "IFRAME" &&
        this.cadastro.dados_cadastrais.tipo !== "LINK" &&
        this.cadastro.dados_cadastrais.tipo !== "RECARGA"
      ) {
        if (this.cadastro.dados_cadastrais.descricao_pt_br === "") {
          this.$config.alert(
            i18n.t("events.event-config.event-name-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.descricao = i18n.t(
            "events.event-config.event-name-error"
          );
          return;
        }
        if (
          (this.cadastro.dados_cadastrais.pre_venda == true &&
            this.cadastro.dados_cadastrais.dthr_pre_venda == "") ||
          (this.cadastro.dados_cadastrais.pre_venda == true &&
            this.cadastro.dados_cadastrais.dthr_pre_venda == null)
        ) {
          this.$config.alert(
            i18n.t("events.event-config.event-exibition-date-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.descricao = i18n.t(
            "events.event-config.event-exibition-date-error"
          );
          return;
        }
        if (this.cadastro.dados_cadastrais.canal_venda.length === 0) {
          if (this.cadastro.dados_cadastrais.tipo === "CORTESIA") {
            this.cadastro.dados_cadastrais.canal_venda = "CORTESIA";
          } else {
            this.$config.alert(
              i18n.t("events.event-config.channel-sale-error"),
              this.$config.dados.errorColor
            );
            this.cadastro.dados_cadastrais.error.canal_venda = i18n.t(
              "events.event-config.channel-sale-error"
            );
          }
          return;
        }

        if (this.cadastro.dados_cadastrais.descricao_pt_br.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.description-length-error"),
            this.$config.dados.errorColor
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.descricao_en_us.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.description-length-error"),
            this.$config.dados.errorColor
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.descricao_es_es.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.description-length-error"),
            this.$config.dados.errorColor
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.status === "") {
          this.$config.alert(
            i18n.t("events.event-config.status-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.status = i18n.t(
            "events.event-config.status-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.tipo === "") {
          this.$config.alert(
            i18n.t("events.event-config.product-type-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.tipo = i18n.t(
            "events.event-config.product-type-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.categoria === "") {
          this.$config.alert(
            i18n.t("events.event-config.category-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.categoria = i18n.t(
            "events.event-config.category-error"
          );
          return;
        }
        if (this.cadastro.dados_cadastrais.categoria === "") {
          this.$config.alert(
            i18n.t("events.event-config.category-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.categoria = i18n.t(
            "events.event-config.category-error"
          );
          return;
        }
        if (this.cadastro.dados_cadastrais.tipo !== "INGRESSO") {
          if (
            this.cadastro.dados_cadastrais.preco === "" ||
            this.cadastro.dados_cadastrais.preco === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.price-error"),
              this.$config.dados.errorColor
            );
            this.cadastro.dados_cadastrais.error.preco = i18n.t(
              "events.event-config.price-error"
            );
            return;
          }
        }

        if (
          this.cadastro.dados_cadastrais.dthr_apresentacao !== null &&
          this.cadastro.dados_cadastrais.dthr_apresentacao.length < 10
        ) {
          this.$config.alert(
            i18n.t("events.event-config.date-time-presentation-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.dthr_apresentacao = i18n.t(
            "events.event-config.date-time-presentation-error"
          );
          return;
        }

        if (
          store.getters?.variations?.length !== 0 &&
          store.getters?.variations?.every(item => +item.quantidade === 0) &&
          this.cadastro.dados_cadastrais.estoque === 0
        ) {
          this.$config.alert(
            i18n.t("events.event-config.stock-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.estoque = i18n.t(
            "events.event-config.stock-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.tipo === "INGRESSO") {
          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.dias_antes.length ===
            0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.dias_antes =
              i18n.t("events.event-config.days-before-error");
            return;
          }

          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.horas_antes
              .length === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.horas_antes =
              i18n.t("events.event-config.hour-before-error");
            return;
          }

          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.dias_depois
              .length === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.dias_depois =
              i18n.t("events.event-config.days-after-error");
            return;
          }

          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.horas_depois
              .length === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.horas_depois =
              i18n.t("events.event-config.hours-after-error");
            return;
          }

          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.limite_uso.length ===
              0 ||
            this.$produtos_gerenciar.cadastro.regra_acesso.limite_uso === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.limite_uso =
              i18n.t("events.event-config.use-limit-error");
            return;
          }
          if (
            !this.cadastro.dados_cadastrais.dthr_apresentacao &&
            !someProductWithOptionDate
          ) {
            this.$config.alert(
              i18n.t("events.event-config.event-date-error"),
              this.$config.dados.errorColor
            );
            this.cadastro.dados_cadastrais.error.dthr_apresentacao = i18n.t(
              "events.event-config.event-date-error"
            );
            return;
          }
        }
        if (this.cadastro.dados_cadastrais.tipo === "CORTESIA") {
          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.dias_antes.length ===
            0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.dias_antes =
              i18n.t("events.event-config.days-before-error");
            return;
          }

          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.horas_antes
              .length === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.horas_antes =
              i18n.t("events.event-config.hours-before-error");
            return;
          }

          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.dias_depois
              .length === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.dias_depois =
              i18n.t("events.event-config.days-after-error");
            return;
          }

          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.horas_depois
              .length === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.horas_depois =
              i18n.t("events.event-config.hours-after-error");
            return;
          }

          if (
            this.$produtos_gerenciar.cadastro.regra_acesso.limite_uso.length ===
              0 ||
            this.$produtos_gerenciar.cadastro.regra_acesso.limite_uso === 0
          ) {
            this.$config.alert(
              i18n.t("events.event-config.access-rules-error"),
              this.$config.dados.errorColor
            );
            this.$produtos_gerenciar.cadastro.regra_acesso.error.limite_uso =
              i18n.t("events.event-config.use-limit-error");
            return;
          }
          if (
            !this.cadastro.dados_cadastrais.dthr_apresentacao &&
            !someProductWithOptionDate
          ) {
            this.$config.alert(
              i18n.t("events.event-config.event-date-error"),
              this.$config.dados.errorColor
            );
            this.cadastro.dados_cadastrais.error.dthr_apresentacao = i18n.t(
              "events.event-config.event-date-error"
            );
            return;
          }
        }
        if (this.cadastro.dados_cadastrais.tipo === "VOUCHER") {
          if (this.cadastro.regra_acesso.dias_depois === 0) {
            this.$config.alert(
              i18n.t("events.event-config.voucher-error"),
              this.$config.dados.errorColor
            );
            this.cadastro.regra_acesso.error.dias_depois = i18n.t(
              "events.event-config.voucher-error"
            );
            return;
          }

          if (this.cadastro.regra_acesso.limite_uso === 0) {
            this.$config.alert(
              i18n.t("events.event-config.voucher-limit-error"),
              this.$config.dados.errorColor
            );
            this.cadastro.regra_acesso.error.limite_uso = i18n.t(
              "events.event-config.voucher-limit-error"
            );
            return;
          }
        }

        if (
          this.cadastro.periodo_vendas.data_inicio === "" ||
          this.cadastro.periodo_vendas.data_inicio === null
        ) {
          this.$config.alert(
            i18n.t("events.event-config.sales-init-date-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.periodo_vendas.error.data_inicio = i18n.t(
            "events.event-config.sales-init-date-error"
          );
          return;
        }

        if (
          this.cadastro.periodo_vendas.hora_inicio === "" ||
          this.cadastro.periodo_vendas.hora_inicio === null
        ) {
          this.$config.alert(
            i18n.t("events.event-config.sales-init-hour-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.periodo_vendas.error.hora_inicio = i18n.t(
            "events.event-config.sales-init-hour-error"
          );
          return;
        }

        if (
          this.cadastro.periodo_vendas.data_termino === "" ||
          this.cadastro.periodo_vendas.data_termino === null
        ) {
          this.$config.alert(
            i18n.t("events.event-config.sales-end-date-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.periodo_vendas.error.data_termino = i18n.t(
            "events.event-config.sales-end-date-error"
          );
          return;
        }

        if (
          this.cadastro.periodo_vendas.hora_termino === "" ||
          this.cadastro.periodo_vendas.hora_termino === null
        ) {
          this.$config.alert(
            i18n.t("events.event-config.sales-end-hour-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.periodo_vendas.error.hora_termino = i18n.t(
            "events.event-config.sales-end-hour-error"
          );
          return;
        }

        if (
          this.cadastro.pre_visualizacao.slug.length < 5 ||
          this.cadastro.pre_visualizacao.slug === ""
        ) {
          this.$config.alert(
            i18n.t("events.event-config.error-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.pre_visualizacao.error.slug = i18n.t(
            "events.event-config.error-error"
          );
          return;
        }

        const images = store.getters.images;

        if (images.length < 2) {
          this.$config.alert(
            i18n.t("events.event-config.two-images-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.customizacao.error.imagem_upload = i18n.t(
            "events.event-config.two-images-error"
          );
          return;
        }

        let destaqueCount = 0;
        let imagem1Count = 0;

        images.forEach(image => {
          if (image.type === "destaque") {
            destaqueCount++;
          } else if (image.type === "imagem1") {
            imagem1Count++;
          }
        });

        if (destaqueCount < 1 || imagem1Count < 1) {
          this.$config.alert(
            i18n.t("events.event-config.required-image-type-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.customizacao.error.imagem_upload = i18n.t(
            "events.event-config.required-image-type-error"
          );
          return;
        }

        if (this.cadastro.pre_visualizacao.slug.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.slug-length-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.pre_visualizacao.error.slug = i18n.t(
            "events.event-config.slug-length-error"
          );
          return;
        }
      } else if (this.cadastro.dados_cadastrais.tipo === "IFRAME") {
        if (this.cadastro.dados_cadastrais.descricao_pt_br === "") {
          this.$config.alert(
            i18n.t("events.event-config.event-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.descricao = i18n.t(
            "events.event-config.event-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.descricao_pt_br.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.description-length-error"),
            this.$config.dados.errorColor
          );
          return;
        }
        if (this.cadastro.dados_cadastrais.status === "") {
          this.$config.alert(
            i18n.t("events.event-config.status-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.status = i18n.t(
            "events.event-config.status-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.tipo === "") {
          this.$config.alert(
            i18n.t("events.event-config.product-type-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.tipo = i18n.t(
            "events.event-config.product-type-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.categoria === "") {
          this.$config.alert(
            i18n.t("events.event-config.category-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.categoria = i18n.t(
            "events.event-config.category-error"
          );
          return;
        }
        if (
          (this.cadastro.dados_cadastrais.preco === "" ||
            this.cadastro.dados_cadastrais.preco === 0) &&
          this.cadastro.dados_cadastrais.tipo !== "INGRESSO"
        ) {
          this.$config.alert(
            i18n.t("events.event-config.price-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.preco = i18n.t(
            "events.event-config.price-error"
          );
          return;
        }
        if (this.cadastro.dados_cadastrais.url_iframe === "") {
          this.$config.alert(
            i18n.t("events.event-config.iframe-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.url_iframe = i18n.t(
            "events.event-config.iframe-error"
          );
          return;
        }
        if (
          this.cadastro.pre_visualizacao.slug.length < 5 ||
          this.cadastro.pre_visualizacao.slug === ""
        ) {
          this.$config.alert(
            i18n.t("events.event-config.slug-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.pre_visualizacao.error.slug = i18n.t(
            "events.event-config.slug-error"
          );
          return;
        }

        const images = store.getters.images;

        if (images.length < 2) {
          this.$config.alert(
            i18n.t("events.event-config.two-images-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.customizacao.error.imagem_upload = i18n.t(
            "events.event-config.two-images-error"
          );
          return;
        }

        let destaqueCount = 0;
        let imagem1Count = 0;

        images.forEach(image => {
          if (image.type === "destaque") {
            destaqueCount++;
          } else if (image.type === "imagem1") {
            imagem1Count++;
          }
        });

        if (destaqueCount < 1 || imagem1Count < 1) {
          this.$config.alert(
            i18n.t("events.event-config.required-image-type-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.customizacao.error.imagem_upload = i18n.t(
            "events.event-config.required-image-type-error"
          );
          return;
        }

        if (this.cadastro.pre_visualizacao.slug.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.slug-length-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.pre_visualizacao.error.slug = i18n.t(
            "events.event-config.slug-length-error"
          );
          return;
        }
      } else if (this.cadastro.dados_cadastrais.tipo === "LINK") {
        if (this.cadastro.dados_cadastrais.descricao_pt_br === "") {
          this.$config.alert(
            i18n.t("events.event-config.event-name-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.descricao = i18n.t(
            "events.event-config.event-name-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.descricao_pt_br.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.description-length-error"),
            this.$config.dados.errorColor
          );
          return;
        }
        if (this.cadastro.dados_cadastrais.status === "") {
          this.$config.alert(
            i18n.t("events.event-config.status-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.status = i18n.t(
            "events.event-config.status-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.tipo === "") {
          this.$config.alert(
            i18n.t("events.event-config.product-type-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.tipo = i18n.t(
            "events.event-config.product-type-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.categoria === "") {
          this.$config.alert(
            i18n.t("events.event-config.category-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.categoria = i18n.t(
            "events.event-config.category-error"
          );
          return;
        }
        if (
          (this.cadastro.dados_cadastrais.preco === "" ||
            this.cadastro.dados_cadastrais.preco === 0) &&
          this.cadastro.dados_cadastrais.tipo !== "INGRESSO"
        ) {
          this.$config.alert(
            i18n.t("events.event-config.price-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.preco = i18n.t(
            "events.event-config.price-error"
          );
          return;
        }
        if (
          this.cadastro.dados_cadastrais.url_link === "" &&
          this.cadastro.dados_cadastrais.prod_agrupamento == 0
        ) {
          this.$config.alert(
            i18n.t("events.event-config.link-url-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.url_link = i18n.t(
            "events.event-config.link-url-error"
          );
          return;
        }
        if (
          this.cadastro.pre_visualizacao.slug.length < 5 ||
          this.cadastro.pre_visualizacao.slug === ""
        ) {
          this.$config.alert(
            i18n.t("events.event-config.slug-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.pre_visualizacao.error.slug = i18n.t(
            "events.event-config.slug-error"
          );
          return;
        }

        const images = store.getters.images;

        if (images.length < 2) {
          this.$config.alert(
            i18n.t("events.event-config.two-images-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.customizacao.error.imagem_upload = i18n.t(
            "events.event-config.two-images-error"
          );
          return;
        }

        let destaqueCount = 0;
        let imagem1Count = 0;

        images.forEach(image => {
          if (image.type === "destaque") {
            destaqueCount++;
          } else if (image.type === "imagem1") {
            imagem1Count++;
          }
        });

        if (destaqueCount < 1 || imagem1Count < 1) {
          this.$config.alert(
            i18n.t("events.event-config.required-image-type-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.customizacao.error.imagem_upload = i18n.t(
            "events.event-config.required-image-type-error"
          );
          return;
        }

        if (this.cadastro.pre_visualizacao.slug.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.slug-length-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.pre_visualizacao.error.slug = i18n.t(
            "events.event-config.slug-length-error"
          );
          return;
        }

        if (
          this.cadastro.dados_cadastrais.prod_agrupamento &&
          this.cadastro.dados_cadastrais.nidprod_agrupamento == ""
        ) {
          this.$config.alert(
            i18n.t("events.event-config.grouped-events-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.nidprod_agrupamento = i18n.t(
            "events.event-config.grouped-events-error"
          );
          return;
        }
      } else if (this.cadastro.dados_cadastrais.tipo === "RECARGA") {
        if (this.cadastro.dados_cadastrais.descricao_pt_br === "") {
          this.$config.alert(
            i18n.t("events.event-config.event-name-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.descricao = i18n.t(
            "events.event-config.event-name-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.descricao_pt_br.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.description-length-error"),
            this.$config.dados.errorColor
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.descricao_en_us.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.description-length-error"),
            this.$config.dados.errorColor
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.descricao_es_es.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.description-length-error"),
            this.$config.dados.errorColor
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.status === "") {
          this.$config.alert(
            i18n.t("events.event-config.status-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.status = i18n.t(
            "events.event-config.status-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.tipo === "") {
          this.$config.alert(
            i18n.t("events.event-config.product-type-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.tipo = i18n.t(
            "events.event-config.product-type-error"
          );
          return;
        }

        if (this.cadastro.dados_cadastrais.categoria === "") {
          this.$config.alert(
            i18n.t("events.event-config.category-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.categoria = i18n.t(
            "events.event-config.category-error"
          );
          return;
        }
        if (this.cadastro.dados_cadastrais.categoria === "") {
          this.$config.alert(
            i18n.t("events.event-config.category-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.categoria = i18n.t(
            "events.event-config.category-error"
          );
          return;
        }
        if (
          (this.cadastro.dados_cadastrais.preco === "" ||
            this.cadastro.dados_cadastrais.preco === 0) &&
          this.cadastro.dados_cadastrais.tipo !== "INGRESSO"
        ) {
          this.$config.alert(
            i18n.t("events.event-config.price-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.preco = i18n.t(
            "events.event-config.price-error"
          );
          return;
        }
        if (
          this.cadastro.variacoes.variacoes_produtos.length === 0 &&
          this.cadastro.dados_cadastrais.estoque === 0 &&
          this.cadastro.dados_cadastrais.gerenciar_estoque
        ) {
          this.$config.alert(
            i18n.t("events.event-config.stock-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.dados_cadastrais.error.estoque = i18n.t(
            "events.event-config.stock-error"
          );
          return;
        }
        if (
          this.cadastro.periodo_vendas.data_inicio === "" ||
          this.cadastro.periodo_vendas.data_inicio === null
        ) {
          this.$config.alert(
            i18n.t("events.event-config.sales-init-date-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.periodo_vendas.error.data_inicio = i18n.t(
            "events.event-config.sales-init-date-error"
          );
          return;
        }

        if (
          this.cadastro.periodo_vendas.hora_inicio === "" ||
          this.cadastro.periodo_vendas.hora_inicio === null
        ) {
          this.$config.alert(
            i18n.t("events.event-config.sales-init-hour-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.periodo_vendas.error.hora_inicio = i18n.t(
            "events.event-config.sales-init-hour-error"
          );
          return;
        }

        if (
          this.cadastro.periodo_vendas.data_termino === "" ||
          this.cadastro.periodo_vendas.data_termino === null
        ) {
          this.$config.alert(
            i18n.t("events.event-config.sales-end-date-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.periodo_vendas.error.data_termino = i18n.t(
            "events.event-config.sales-end-date-error"
          );
          return;
        }

        if (
          this.cadastro.periodo_vendas.hora_termino === "" ||
          this.cadastro.periodo_vendas.hora_termino === null
        ) {
          this.$config.alert(
            i18n.t("events.event-config.sales-end-time-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.periodo_vendas.error.hora_termino = i18n.t(
            "events.event-config.sales-end-time-error"
          );
          return;
        }

        if (
          this.cadastro.pre_visualizacao.slug.length < 5 ||
          this.cadastro.pre_visualizacao.slug === ""
        ) {
          this.$config.alert(
            i18n.t("events.event-config.slug-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.pre_visualizacao.error.slug = i18n.t(
            "events.event-config.slug-error"
          );
          return;
        }

        const images = store.getters.images;

        if (images.length < 2) {
          this.$config.alert(
            i18n.t("events.event-config.two-images-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.customizacao.error.imagem_upload = i18n.t(
            "events.event-config.two-images-error"
          );
          return;
        }

        let destaqueCount = 0;
        let imagem1Count = 0;

        images.forEach(image => {
          if (image.type === "destaque") {
            destaqueCount++;
          } else if (image.type === "imagem1") {
            imagem1Count++;
          }
        });

        if (destaqueCount < 1 || imagem1Count < 1) {
          this.$config.alert(
            i18n.t("events.event-config.required-image-type-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.customizacao.error.imagem_upload = i18n.t(
            "events.event-config.required-image-type-error"
          );
          return;
        }

        if (this.cadastro.pre_visualizacao.slug.length > 65) {
          this.$config.alert(
            i18n.t("events.event-config.slug-length-error"),
            this.$config.dados.errorColor
          );
          this.cadastro.pre_visualizacao.error.slug = i18n.t(
            "events.event-config.slug-length-error"
          );
          return;
        }
      }
      if (this.produtosAddEdit == "editar") {
        this.alterarProduto();
        return;
      }

      this.cadastrarProduto();
    },

    /**
     * @description Método para gerar um SKU
     * @param {option_descricao} String - Descrição do produto
     */
    SKUGenerator(option_descricao) {
      if (
        this.cadastro.dados_cadastrais.tipo !== "" &&
        this.cadastro.dados_cadastrais.descricao_pt_br !== "" &&
        option_descricao !== ""
      ) {
        const SKU =
          this.cadastro.dados_cadastrais.tipo.substring(0, 2) +
          this.cadastro.dados_cadastrais.descricao_pt_br.substring(0, 2) +
          option_descricao.substring(0, 2) +
          Math.floor(Math.random() * 99999999 + 1);
        return SKU.toUpperCase();
      }
    },
    limpaFormularioDeProduto() {
      //taxas
      store.commit("setDigitalWallet", [
        {
          dias: "2",
          tipo: "pos",
          limite: 80,
          saque: "manual",
        },
      ]);
      this.cadastro.dados_cadastrais.pre_venda = false;
      this.cadastro.dados_cadastrais.dthr_pre_venda = "";
      this.cadastro.dados_cadastrais.valor_taxa_web = "";
      this.cadastro.dados_cadastrais.percentual_taxa_web = "10";
      this.cadastro.dados_cadastrais.tipoComissaoWeb = "CONVENIENCIA";
      this.cadastro.dados_cadastrais.tipoComissaoPos = "COMISSAO";
      this.cadastro.dados_cadastrais.tipoTaxaPos = "PERCENTUAL";
      this.cadastro.dados_cadastrais.percentual_taxa_pos = "7.4";
      this.cadastro.dados_cadastrais.valor_taxa_pos = "0";
      (this.cadastro.dados_cadastrais.tipoComissaoWeb = "CONVENIENCIA"),
        (this.cadastro.dados_cadastrais.tipoTaxaWeb = "PERCENTUAL"),
        (this.cadastro.dados_cadastrais.valor_taxa_web = "0"),
        // dados cadastrais
        (this.cadastro.dados_cadastrais.descricao_pt_br = "");
      this.cadastro.dados_cadastrais.taxa_processamento = "";
      this.cadastro.dados_cadastrais.ver_mais = false;
      this.cadastro.dados_cadastrais.descricao_en_us = "";
      this.cadastro.dados_cadastrais.descricao_es_es = "";
      this.cadastro.dados_cadastrais.descritivo_pt_br = "";
      this.cadastro.dados_cadastrais.descritivo_en_us = "";
      this.cadastro.dados_cadastrais.descritivo_es_es = "";
      this.cadastro.dados_cadastrais.status = "";
      this.cadastro.dados_cadastrais.loja = "";
      this.cadastro.dados_cadastrais.tipo = "";
      this.cadastro.dados_cadastrais.preco = 0;
      this.cadastro.dados_cadastrais.preco_promocional = 0;
      // this.cadastro.dados_cadastrais.custo = 0;
      this.cadastro.dados_cadastrais.estoque = 0;
      this.cadastro.dados_cadastrais.sku = "";
      this.cadastro.dados_cadastrais.categoria = "";
      this.cadastro.dados_cadastrais.destaque = false;
      this.cadastro.dados_cadastrais.gerenciar_estoque = 1;
      this.cadastro.dados_cadastrais.controla_cancelamento = 1;
      this.cadastro.dados_cadastrais.tags = "";
      this.cadastro.dados_cadastrais.tem_traducao = false;
      this.cadastro.dados_cadastrais.endereco = "";
      this.cadastro.dados_cadastrais.dthr_apresentacao = null;
      this.cadastro.dados_cadastrais.canal_venda = "";
      this.cadastro.dados_cadastrais.url_iframe = "";
      this.cadastro.dados_cadastrais.url_link = "";
      this.cadastro.dados_cadastrais.limite_venda_cpf = 0;
      this.cadastro.dados_cadastrais.pais = "Brasil";
      this.cadastro.dados_cadastrais.estado = "";
      this.cadastro.dados_cadastrais.cidade = "";
      this.cadastro.dados_cadastrais.mapa_hospedagem = true;
      this.cadastro.dados_cadastrais.error.descricao = "";
      this.cadastro.dados_cadastrais.error.descritivo = "";
      this.cadastro.dados_cadastrais.error.status = "";
      this.cadastro.dados_cadastrais.error.loja = "";
      this.cadastro.dados_cadastrais.error.limite_venda_cpf = "";
      this.cadastro.dados_cadastrais.error.tipo = "";
      this.cadastro.dados_cadastrais.error.preco = "";
      this.cadastro.dados_cadastrais.error.preco_promocional = "";
      this.cadastro.dados_cadastrais.error.estoque = "";
      this.cadastro.dados_cadastrais.error.sku = "";
      this.cadastro.dados_cadastrais.error.dthr_apresentacao = null;
      this.cadastro.dados_cadastrais.error.canal_venda = "";
      this.cadastro.dados_cadastrais.error.url_iframe = "";
      this.cadastro.dados_cadastrais.error.url_link = "";
      this.cadastro.dados_cadastrais.prod_agrupamento = 0;
      this.cadastro.dados_cadastrais.exibe_agrupamento = 0;
      this.cadastro.dados_cadastrais.nidprod_agrupamento = "";
      // regras de acesso
      this.cadastro.regra_acesso.dias_antes = "";
      this.cadastro.regra_acesso.horas_antes = "";
      this.cadastro.regra_acesso.dias_depois = "";
      this.cadastro.regra_acesso.horas_depois = "";
      this.cadastro.regra_acesso.limite_uso = "";
      this.cadastro.regra_acesso.portador = 0;
      this.cadastro.regra_acesso.error.dias_antes = "";
      this.cadastro.regra_acesso.error.horas_antes = "";
      this.cadastro.regra_acesso.error.dias_depois = "";
      this.cadastro.regra_acesso.error.horas_depois = "";
      this.cadastro.regra_acesso.error.limite_uso = "";
      this.cadastro.regra_acesso.circus = false;
      this.cadastro.regra_acesso.is_facial = false;

      // periodo de vendas
      this.cadastro.periodo_vendas.por_data_lote = 0;
      this.cadastro.periodo_vendas.data_inicio = null;
      this.cadastro.periodo_vendas.initDate = null;
      this.cadastro.periodo_vendas.hora_inicio = null;
      this.cadastro.periodo_vendas.initHour = null;
      this.cadastro.periodo_vendas.data_termino = null;
      this.cadastro.periodo_vendas.endDate = null;
      this.cadastro.periodo_vendas.hora_termino = null;
      this.cadastro.periodo_vendas.endHour = null;
      this.cadastro.periodo_vendas.comeco_vendas_data = "";
      this.cadastro.periodo_vendas.termino_vendas_data = "";
      this.cadastro.periodo_vendas.termino_vendas_hora = "";
      this.cadastro.periodo_vendas.error.data_inicio = "";
      this.cadastro.periodo_vendas.error.hora_inicio = "";
      this.cadastro.periodo_vendas.error.data_termino = "";
      this.cadastro.periodo_vendas.error.hora_termino = "";

      // variações
      this.cadastro.variacoes.tem_variacoes = false;
      this.cadastro.variacoes.gerenciar_lote = false;
      this.cadastro.variacoes.opcoes = [];
      this.cadastro.variacoes.variacoes_produtos = [];
      this.cadastro.variacoes.variacoes_pronto = true;
      this.cadastro.variacoes.error.tipo = "";

      // customização
      this.cadastro.customizacao.imagem = "";
      this.cadastro.customizacao.imagens_array = [];
      this.cadastro.customizacao.loading_imagem = false;
      delete this.cadastro.customizacao.imagem_upload.object,
        (this.cadastro.customizacao.error.imagem = "");

      //  pre-visualização
      this.cadastro.pre_visualizacao.personalizar = "";
      this.cadastro.pre_visualizacao.link = "";
      this.cadastro.pre_visualizacao.slug = "";
      this.cadastro.pre_visualizacao.error.slug = "";

      // cashless
      this.cadastro.cashless.url_cashless_prod = "";
    },

    limpaFiltros() {
      this.filter.descricao = "";
      this.filter.sku = "";
      this.filter.loja = "";
      this.filter.status = "";
      this.filtros = [];
    },
  },
});
